let l = location;
export const DOMAIN    = `${l.host}`;
const PROTOCOL         = "http://"
const POSTFIX          = "api";
const VERSION          = "v1";
const NAMESPACE        = "";

// const BASE_URL = `${DOMAIN}/${NAMESPACE}/${POSTFIX}`;
const BASE_URL = `${l.protocol}//${DOMAIN}/${POSTFIX}/${POSTFIX}`;
const BASE_WS_URL = `ws://${DOMAIN}/${POSTFIX}`;
export default {
  NAMESPACE,
  api: {
    DOMAIN,
    BASE_URL,
    BASE_WS_URL
  }
}